import { useMutation } from 'react-query';

import { registerWithFullCredentials } from '../services';

export const useSignUpFull = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: registerWithFullCredentials,
    onSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const message = error?.response?.data?.payload?.message;

      onError?.(message || 'Something went wrong...');
    },
  });
};
